var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0074 0.000831479C4.48324 0.000473868 0.00504757 4.44789 0.00605798 9.97207C0.0093246 27.8316 0.0144854 65.6782 0.00523806 90.0081C0.00313786 95.5337 4.45009 99.9998 9.9757 99.9998C27.8392 100 65.6902 100 90.0188 99.9998C95.5415 99.9997 100.003 95.5539 100.003 90.0312C100.003 72.1716 100.003 34.3163 100.003 9.98523C100.003 4.46248 95.5262 0.000677933 90.0034 0.000664793C63.3381 0.000601352 36.6728 0.00255768 10.0074 0.000831479Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3782 50.0002H70.7533V37.5003C70.7533 34.0504 73.5533 34.3754 77.0033 34.3754H83.2532V18.7505H70.7533C60.3972 18.7505 52.0035 27.1442 52.0035 37.5003V50.0002H39.5036V65.6251H52.0035V99.9998H70.7533V65.6251H80.1282L86.3782 50.0002Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBig);
export default __webpack_public_path__ + "static/media/FacebookBig.868463ae67379c4013442a9c8e5059af.svg";
export { ForwardRef as ReactComponent };